/* eslint-disable react-refresh/only-export-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, FC, useContext, useEffect, useState } from 'react';

interface WithChildren {
  children?: React.ReactNode;
}

export interface NavigationDataContextModel {
  headerText?: string;
  setHeaderText: (_headerText?: string) => void;
  buttonText?: string;
  setButtonText: (_buttonText?: string) => void;
  path?: string;
  setPath: (_path?: string) => void;
}

const NavigationDataContext = createContext<NavigationDataContextModel>({
  setHeaderText: (_headerText?: string) => {},
  setButtonText: (_buttonText?: string) => {},
  setPath: (_path?: string) => {},
});

const NavigationDataProvider: FC<WithChildren> = ({ children }) => {
  const [headerText, setHeaderText] = useState<string>();
  const [buttonText, setButtonText] = useState<string>();
  const [path, setPath] = useState<string>();

  const value: NavigationDataContextModel = {
    headerText,
    setHeaderText,
    buttonText,
    setButtonText,
    path,
    setPath,
  };

  return (
    <NavigationDataContext.Provider value={value}>
      {children}
    </NavigationDataContext.Provider>
  );
};

function useNavigationData() {
  return useContext(NavigationDataContext);
}

const HeaderText: FC<WithChildren> = ({ children }) => {
  const { setHeaderText } = useNavigationData();

  useEffect(() => {
    if (children) {
      setHeaderText(children.toString());
    }
    return () => {
      setHeaderText(undefined);
    };
  }, [children]);

  return <></>;
};

const ButtonText: FC<WithChildren> = ({ children }) => {
  const { setButtonText } = useNavigationData();

  useEffect(() => {
    if (children) {
      setButtonText(children.toString());
    }
    return () => {
      setButtonText(undefined);
    };
  }, [children]);

  return <></>;
};

const Path: FC<WithChildren> = ({ children }) => {
  const { setPath } = useNavigationData();

  useEffect(() => {
    if (children) {
      setPath(children.toString());
    }

    return () => {
      setPath(undefined);
    };
  }, [children]);

  return <></>;
};

export {
  NavigationDataProvider,
  ButtonText,
  HeaderText,
  Path,
  useNavigationData,
};
